/**
 **  rem.useRem(750,100)
 **/

function computeRem(baseWidth, baseRem) {
    var winWidth = document.documentElement.clientWidth;
    if (winWidth <= 320) winWidth = 320;
    if (winWidth >= baseWidth) winWidth = baseWidth;
    var targetRem = winWidth / (baseWidth / 2) * baseRem;
    document.documentElement.style.fontSize = targetRem + "px";
}

let rem = {
    useRem: function (baseWidth, baseRem) {
        computeRem(baseWidth, baseRem);
        window.addEventListener("resize", function () {
            computeRem(baseWidth, baseRem)
        });
    }
}


let fixMoney = (num) => {
    var beforeIcon = num < 0 ? "-" : ""
    num = Math.abs(num)
    var num = (parseInt(num) || 0).toString(), result = '';

    while (num.length > 3) {
        result = ',' + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
    }
    if (num) {
        result = num + result;
    }
    return beforeIcon + result;
}

let getUrlString = (name) => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
}

let pageLockHandler = (e) => {
    e.preventDefault();
}

// 锁定页面
let pageLock = () => {
    document.addEventListener("touchmove", pageLockHandler, {passive: false})
}

// 解锁页面
let pageUnlock = () => {
    document.removeEventListener("touchmove", pageLockHandler, {passive: false})
}

//补0
let _addZero = (time) => {
    let str = time;
    if (Math.abs(time) < 10) {
        str = '0' + time;
    }
    return str;
}

//计算时间
let computeTime = (second) => {
    var hourTime = 0;
    var minuteTime = 0;
    var secondTime = 0;
    if (second > 60) {  //如果秒数大于60
        minuteTime = Math.floor(second / 60);
        secondTime = Math.floor(second % 60);
        if (minuteTime >= 60) {  //如果分钟大于60
            hourTime = Math.floor(minuteTime / 60);
            minuteTime = Math.floor(minuteTime % 60);
        } else {
            hourTime = 0;
        }
    } else {
        hourTime = 0;
        minuteTime = 0;
        if (second == 60) {  //如果秒数等于60
            minuteTime = 1;
            secondTime = 0;
        } else {
            secondTime = second;
        }
    }
    var timeResult = _addZero(hourTime) + ':' + _addZero(minuteTime) + ':' + _addZero(secondTime);
    return timeResult;
}

//随机顺序
let shuffle = (arr) => {
    let len = arr.length;
    for (let i = 0; i < len - 1; i++) {
        let index = parseInt(Math.random() * (len - i));
        let temp = arr[index];
        arr[index] = arr[len - i - 1];
        arr[len - i - 1] = temp;
    }
    return arr;
}

//判断系统
let getSystem = () => {
    let ua = navigator.userAgent.toLowerCase();
    let browser = "other"
    let appType = {
        mqq: ua.indexOf('_sq_') > -1 || false,
        wx: ua.indexOf('micromessenger') > -1 || false,
        jdApp: ua.indexOf('jdapp') > -1 || false,
        jrApp: ua.indexOf('jdjr') > -1 || ua.indexOf('android-async-http') > -1 || false,
    }
    for (let i in appType) {
        if (appType[i]) {
            browser = i;
        }
    }
    return browser
}

//formatTime(time,'yyyy-MM-dd HH:mm:ss')
let formatTime = (time, format) => {
    var t = new Date(time);
    var tf = function (i) {
        return (i < 10 ? '0' : '') + i
    };
    return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
        switch (a) {
            case 'yyyy':
                return tf(t.getFullYear());
                break;
            case 'MM':
                return t.getMonth() + 1;
                break;
            case 'mm':
                return tf(t.getMinutes());
                break;
            case 'dd':
                return tf(t.getDate());
                break;
            case 'HH':
                return tf(t.getHours());
                break;
            case 'ss':
                return tf(t.getSeconds());
                break;
        }
    })
}


export default {
    rem: rem,
    fixMoney: fixMoney,
    fixZero: _addZero,
    computeTime: computeTime,
    getUrlString: getUrlString,
    pageLock: pageLock,
    pageUnlock: pageUnlock,
    shuffle: shuffle,
    getSystem: getSystem,
    formatTime: formatTime
}
